export default __webpack_public_path__ + "static/media/image7.c12d651c.jpg";